module.exports = __webpack_public_path__ + "img/6_cover1.25cd81ee.png";